import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import AssessmentForm from './components/AssessmentForm';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <Routes>
          <Route path="/" element={<AssessmentForm />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;